import { computed, ref } from 'vue'

import { defineStore } from 'pinia'
import { ItemInfo } from './types.js'

type FilteredItem = {
  /**
   * The current count of all visible items
   */
  count: number
  /**
   * Set of item identifiers that are visible.
   */
  items: string[]
  /**
   * Set of groups with at least one visible item.
   */
  groups: string[]
}

export const useCommandStore = (id: string) =>
  defineStore(`command-${id}`, () => {
    // State

    /**
     * Currently selected item value
     */
    const value = ref('')
    /**
     * Value of the search query.
     */
    const search = ref('')
    /**
     * All items currently registered
     */
    const items = ref<ItemInfo[]>([])
    /**
     * Filtered items state
     */
    const filtered = ref<FilteredItem>({
      count: 0,
      items: [],
      groups: [],
    })

    // Getters
    const isSearching = computed(() => search.value !== '')

    // Actions
    function resetStore() {
      search.value = ''
      filtered.value.count = 0
      filtered.value.items = []
      filtered.value.groups = []
    }

    function registerItem(item: ItemInfo) {
      const itemIndex = items.value.findIndex((i) => i.itemId === item.itemId)
      if (itemIndex === -1) {
        items.value.push(item)
      }
    }

    function deregisterItem(item: ItemInfo) {
      const itemIndex = items.value.findIndex((i) => i.itemId === item.itemId)
      if (itemIndex !== -1) {
        items.value.splice(itemIndex, 1)
      }
    }

    return {
      search,
      value,
      items,
      filtered,
      isSearching,
      resetStore,
      registerItem,
      deregisterItem,
    }
  })()
